import initializeSvelteApp from "common/initializeSvelteApp";
import App from "./App.svelte";

initializeSvelteApp({
  component: App,
  target: ".js-order-convert-season-pass-to-subscription",
  props: (element) => {
    return {
      urls: JSON.parse(element.getAttribute("data-urls")),
      orderItems: JSON.parse(element.getAttribute("data-order-items")),
      subscriptionItemTypes: JSON.parse(
        element.getAttribute("data-subscription-item-types")
      ),
    };
  },
});
